var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.258 24.0625C25.1812 24.1955 25.0707 24.306 24.9377 24.3828C24.8046 24.4596 24.6537 24.5 24.5001 24.5H3.50008C3.34656 24.4998 3.19579 24.4593 3.06289 24.3824C2.93 24.3056 2.81967 24.1951 2.74298 24.0621C2.66629 23.9291 2.62594 23.7783 2.62598 23.6248C2.62602 23.4713 2.66645 23.3205 2.7432 23.1875C4.40899 20.3077 6.97602 18.2427 9.9718 17.2638C8.48995 16.3816 7.33865 15.0374 6.69469 13.4376C6.05073 11.8378 5.94974 10.0708 6.4072 8.40805C6.86467 6.74528 7.85531 5.27865 9.22698 4.23339C10.5987 3.18812 12.2755 2.62202 14.0001 2.62202C15.7246 2.62202 17.4015 3.18812 18.7732 4.23339C20.1449 5.27865 21.1355 6.74528 21.593 8.40805C22.0504 10.0708 21.9494 11.8378 21.3055 13.4376C20.6615 15.0374 19.5102 16.3816 18.0284 17.2638C21.0241 18.2427 23.5912 20.3077 25.257 23.1875C25.3339 23.3204 25.3745 23.4713 25.3747 23.6249C25.3749 23.7784 25.3347 23.9294 25.258 24.0625Z",
    fill: "#2A2E37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFill);
export default __webpack_public_path__ + "static/media/my-fill.067cfa62c2f659359f21cfee9df96299.svg";
export { ForwardRef as ReactComponent };